"use strict";

/* A service / model */

_BannerFlowApp.factory("Folder", function ($resource, AuthInfo) {
    return $resource(
        "",
        {
            id: "@id"
        },
        {
            create: {
                method: "POST",
                url: "{0}/api/brands/{1}/folders".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                )
            },
            rename: {
                method: "PUT",
                url: "{0}/api/brands/{1}/folders/rename".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                )
            },
            drop: {
                method: "PUT",
                url: "{0}/api/brands/{1}/folders/move".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                )
            }
        }
    );
});
